module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-bar"
  }, [_c('v-toolbar', {
    staticClass: "elevation-2 pf-toolbar",
    attrs: {
      "color": "secondary",
      "dark": "",
      "app": "",
      "clipped-left": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0",
    staticStyle: {
      "width": "300px"
    }
  }, [(_vm.userIsAdmin()) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideDrawer($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "logo-span"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/property-first.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-search")])], 1)], 1), _vm._v(" "), _c('v-toolbar-items', [(_vm.userIsAuthenticated()) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person")]), _vm._v("  " + _vm._s(_vm.currentUser().firstName) + "\n    ")], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onLogout($event)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6d01534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ToolBar.vue
// module id = 361
// module chunks = 4